<template>
  <b-modal
    id="delete-devices-licenses-modal"
    scrollable
    header-bg-variant="danger"
    header-text-variant="white"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
  >
    <div>
      <div class="alert alert-danger" role="alert">
        <strong>Recordatorio.</strong> El registro del dispositivo no se borra, pero su UUID quedará inhabilitado y no podrá usarse para iniciar sesión. Para habilitarlo se deberá reinstalar la aplicación.
      </div>
      <p>
        Esta acción realiza un cambio de estado del dispositivo a RESETTLE,
        esto inactiva todas las licencias relacionadas al dispositivo.
      </p>
      <p class="mb-0">
        Estás por eliminar {{ devices && devices.length > 1 ? 'los dispositivos' : 'el dispositivo' }}:
      </p>
      <ul class="reset-devices-list" v-if="devices && devices.length > 0">
        <li class="reset-devices-item" v-for="device in devices" :key="device.id">
          <div class="device-info">
            <div class="device-id">{{device.id}} <i class="fas fa-mobile"></i></div>
            <div><p class="device-info-tag">Nombre:</p> {{ device.name }}</div>
            <div><p class="device-info-tag">UUID:</p> {{device.uuid}}</div>
            <div><p class="device-info-tag">Estado:</p> {{ deviceClass.getStatus(device.status) }}</div>
          </div>
        </li>
      </ul>
      <div class="release-action-confirm">
        Favor de marca la casilla para confirmar
        <b-checkbox v-model="resetDevicesConfirmation">Sí, estoy seguro</b-checkbox>
      </div>
    </div>
    <template v-slot:modal-title>
      <div class="inline">
        <i class="fas fa-skull"></i>
        Eliminación de dispositivos
      </div>
    </template>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeDeleteDevicesModal">
        Cancelar
      </b-button>
      <b-button variant="danger" :disabled="!resetDevicesConfirmation" @click="deleteDevices(devices)">
        Eliminar <i class="fa fa-skull"></i>
      </b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import CatalogsService from '@/services/CatalogsService'
import { Device } from '@/types/catalogs/Devices'

@Component({
  name: 'ResetLicenseDeviceModal'
})
export default class ResetLicenseDeviceModal extends Vue {
  @Prop({ required: true })
  devices: Device[]

  @Prop({ required: false, default: false })
  fromAdminLicensesList: boolean

  resetDevicesConfirmation: boolean = false
  deviceClass = Device
  /**
   * Calls the DELETE function for every device on the list
   * that receives as parameter, and display a toast for each promise resolved
   *
   * @param devices to reset (delete)
   */
  async deleteDevices (devices: Device[]) {
    let devicesToReset: Promise<Device>[] = []
    devices.forEach(device => {
      const request = CatalogsService.deleteDeviceById(device.id)
      const licenseResponse = `El dispositivo: ${device.id} - ${device.name} - ${device.uuid}`
      devicesToReset.push(request)
      request
        .then((response) => {
          this.$bvToast.toast(`${licenseResponse} ha sido eliminado.`, {
            title: 'Eliminado correctamente',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            solid: true,
            autoHideDelay: 5000
          })
        })
        .catch((error) => {
          // Manage current and future error format
          let dataError = error.response.data
          let errors = []
          if (dataError.errors) {
            dataError.errors.forEach((e: any) => {
              errors.push(e.description)
            })
          } else {
            errors.push(dataError.description ? dataError.description : error.response)
          }
          this.$bvToast.toast(`${licenseResponse} no se ha podido eliminar. ${errors.join(', ')}`, {
            title: 'Error al eliminar',
            variant: 'danger',
            toaster: 'b-toaster-top-left',
            solid: true,
            autoHideDelay: 5000
          })
        })
    })
    await Promise.allSettled(devicesToReset)
      .finally(() => {
        this.$emit('update-licenses-list', this.fromAdminLicensesList)
        this.$emit('update-devices-list')
      })
    this.closeDeleteDevicesModal()
  }

  /**
   * Hides modal for reset devices
   * and turn off the confirmation flag
   */
  closeDeleteDevicesModal () {
    this.resetDevicesConfirmation = false
    this.$bvModal.hide('delete-devices-licenses-modal')
  }
}
</script>

<style lang="scss" scoped>

$gray-200: #e9ecef !default;

// Styles for delete licenses modal
.reset-devices-list {
  padding: 0.5em 0 0 0;
  margin-bottom: 0;

  .reset-devices-item {
    list-style-type: none;
    padding: 0.5em;
    box-shadow: -5px 0 1px -1px #000;
    border-radius: 0 10px 10px 0;
    margin-bottom: 0.5em;
    background-color: $gray-200;

    .device-info {
      font-weight: normal;

      .device-info-tag {
        font-weight: bold;
        display: inline;
      }
      .device-id {
        margin: 0;
        float: right;
        padding-right: 0.25em;
        font-size: 1.5em;
        font-weight: bold;
      }
    }
  }
}
</style>
